<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información de la Órden">
          <b-form>
            <app-rubro-trabajo
              label="Rubro"
              :nombre="rubroTrabajoNombre"
              :readOnly="rubroReadOnly"
              :valido="rubroTrabajoValido"
              :lista="rubrosList"
              :msjInvalido="rubroTrabajoInvalidoMsj"
              :labelCols= "labelCols"
              @validate="validate"
              @updated="rubroTrabajoActualizado">
            </app-rubro-trabajo>  

            <b-form-group
              label=""
              label-for="rubroTrabajoDescripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="rubroTrabajoDescripcion"
                :value= "rubroTrabajoDescripcion" 
                rows="2"
                max-rows="2"
                readonly>
              </b-form-textarea>
            </b-form-group>

            <app-categoria-servicio
              v-if="discriminarCategoriaServicio"
              label="Categoría"
              :nombre="categoriaServicioNombre"
              :readOnly="readOnly"
              :valido="categoriaServicioValida"
              :lista="categoriasServiciosList"
              :msjInvalido="categoriaServicioInvalidaMsj"
              :labelCols= "labelCols"
              description="Categoría de Servicio"
              @validate="validate"
              @updated="categoriaServicioActualizada">
            </app-categoria-servicio>  

            <b-form-group
              label="Título"
              label-for="titulo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titulo"
                v-model.trim= "$v.titulo.$model" 
                :state="tituloValido"
                :readonly="readOnly"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="tituloFeedback">
                {{ tituloInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              description="Descripción a incluir en el Presupuesto al Cliente"
              horizontal>
              <b-form-textarea
                id="descripcion"
                :readonly="!isDescripcionEditable"
                v-model="$v.descripcion.$model" 
                rows="3"
                max-rows="3"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>

              <i v-if="gptVisible"
                class="fa fa-microphone icon-action"
                @click.prevent="askTranscriptionGpt"/>
            </b-form-group>

            <app-moneda
              label="Moneda"
              :nombre="monedaNombre"
              :labelCols="labelCols"
              :valido="monedaValida"
              :lista="monedasList"
              :msjInvalido="monedaInvalidaMsj"
              @validate="validate"
              @updated="monedaActualizada">
            </app-moneda>  

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Cantidad"
                  label-for="cantidad"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cantidad"
                    v-model.trim= "$v.cantidad.$model" 
                    :state="cantidadValida"
                    :readonly="readOnly"
                    type="text"
                    @blur.native="validate"
                    @input.native="calcularCostos">
                  </b-form-input>
                  <b-form-invalid-feedback id="cantidadFeedback">
                    {{ cantidadInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Unitario"
                  label-for="costoEstimado"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text v-if="!readOnly">
                      <b-form-radio v-model="costoUnitario" 
                        name="costoUnitarioSelected" 
                        :value="Boolean(true)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <app-formatted-costo-unitario
                      id="costoEstimado"
                      :importe="costoEstimado"
                      :moneda="monedaNombre"
                      cssClass="form-control"
                      :readonly="costoDisabled"
                      @actualizarImporte="actualizarCostoUnitario">
                    </app-formatted-costo-unitario>
                    <!-- <b-form-input 
                      id="costoEstimado" 
                      v-model.trim= "$v.costoEstimado.$model" 
                      type="text"
                      :readonly="costoDisabled"
                      :state="costoEstimadoValido"
                      @blur.native="validate"
                      @input.native="calcularCostoTotal">
                    </b-form-input> -->
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoFeedback">
                    {{ costoEstimadoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Total"
                  label-for="costoEstimadoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text v-if="!readOnly">
                      <b-form-radio v-model="costoUnitario" 
                        name="costoTotalSelected" 
                        :value="Boolean(false)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <app-formatted-costo-total
                      id="costoEstimadoTotal"
                      :importe="costoEstimadoTotal"
                      :moneda="monedaNombre"
                      cssClass="form-control"
                      :readonly="costoTotalDisabled"
                      @actualizarImporte="actualizarCostoTotal">
                    </app-formatted-costo-total>
                    <!-- <b-form-input 
                      id="costoEstimadoTotal" 
                      v-model.trim= "$v.costoEstimadoTotal.$model" 
                      type="text"
                      :readonly="costoTotalDisabled"
                      :state="costoEstimadoTotalValido"
                      @blur.native="validate"
                      @input.native="calcularCostoUnitario">
                    </b-form-input> -->
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoTotalFeedback">
                    {{ costoEstimadoTotalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cerrar</b-button>
            
            <!-- <b-button size="sm" variant="secondary" class="footer-button"
              @click.prevent="askGpt">Ask GPT</b-button> -->
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="gptModal"
        title="Descripción de la Orden"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-gpt
        :current="descripcion"
        :rubroTrabajoId="rubroTrabajoId"
        @close="closeGpt">
      </app-gpt>  
    </b-modal>

    <b-modal ref="gptTranscriptionModal"
        title="Descripción de la Orden"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transcription-gpt
        @close="closeTranscriptionGpt">
      </app-transcription-gpt>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import RubroTrabajo from '../shared/abmSelect.vue';
import CategoriaServicio from '../shared/abmSelect.vue';
import Moneda from '../shared/abmSelect.vue';
import Imagenes from './Imagenes.vue';
import gptModal from '../shared/gptModal.vue';
import gptTranscriptionModal from '../shared/gptTranscriptionModal.vue';
import FormattedCostoUnitario from '../shared/formattedCurrency.vue';
import FormattedCostoTotal from '../shared/formattedCurrency.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordentrabajo/getField',
  mutationType: 'ordentrabajo/updateField',
});

export default {
  name: 'OrdenesTrabajosABM',
  props: {
    ordenId: {
      type: Number,
      default: 0
    },
    vistaProduccion: {
      type: Boolean,
      default: false
    },
    altaOrden: {
      type: Boolean,
      default: true
    }
  },
  components: {
    appRubroTrabajo: RubroTrabajo,
    appCategoriaServicio: CategoriaServicio,
    appMoneda: Moneda,
    appImagenes: Imagenes,
    appFormattedCostoUnitario: FormattedCostoUnitario,
    appFormattedCostoTotal: FormattedCostoTotal,
    appMensaje: Mensaje,
    appGpt: gptModal,
    appTranscriptionGpt: gptTranscriptionModal
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      rubroTrabajoValido: null,
      rubroTrabajoInvalidoMsj: '',
      categoriaServicioValida: null,
      categoriaServicioInvalidaMsj: '',
      tituloValido: null,
      tituloInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      cantidadValida: null,
      cantidadInvalidaMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      costoEstimadoValido: null,
      costoEstimadoInvalidoMsj: '',
      costoEstimadoTotalValido: null,
      costoEstimadoTotalInvalidoMsj: '',

      categoriasServicios: [],
      categoriasServiciosList: [],
      monedas: [],
      monedasList: [],

      labelCols: 2,
      inicializandoRubros: false,
      inicializandoCategorias: false,
      inicializandoMonedas: false,

      showImagenes: false,
      accesoEdicionDescripcion: false,

      gptVisible: false,
      rubroReadOnly: false
    }
  },
  computed: {
    ...mapFields([
      'ordenTrabajo',
      'rubroTrabajo',
      'rubroTrabajoNombre',
      'rubroTrabajoDescripcion',
      'categoriaServicio',
      'categoriaServicioNombre',
      'titulo',
      'descripcion',
      'cantidad',
      'monedaId',
      'moneda',
      'monedaNombre',
      'costoEstimado',
      'costoEstimadoTotal',
      'costoUnitario',
      'feeAgencia',
      'readOnly',
      'rubros',
      'rubrosList',
      'discriminarCategoriaServicio'
    ]),
    rubroTrabajoId() {
      if (this.rubroTrabajo) {
        return this.rubroTrabajo.id;
      }
      return 0;
    },
    costoDisabled() {
      return !this.costoUnitario;
    },
    costoTotalDisabled() {
      return Boolean(this.costoUnitario);
    },
    isDescripcionEditable() {
      if (!this.readOnly) {
        return true;
      }

      /* Validamos si tiene acceso para editar descripciones de ordenes certificadas */
      return this.accesoEdicionDescripcion;
    }
  },  
  created() {
    if (this.ordenId != 0) {
      this.$store.dispatch('ordentrabajo/inicializarOrden', this.ordenId)
        .then(() => this.getDatosAdicionales());
    } else {
      this.getDatosAdicionales();
    }

    const userId = parseInt(this.$store.getters['user/userId']);
    if (userId == 1 || userId == 2 || userId == 16 || userId == 17 || userId == 32) {
      this.gptVisible = true;
    }

    this.accesoEdicionDescripcion = Boolean(this.$store.getters['user/tieneAccesoModulo']('OrdenesTrabajoEditarDescripcionCertificados'));

    if (this.readOnly) {
      this.rubroReadOnly = !this.$store.getters['user/tieneAccesoModulo']('OrdenesTrabajoEditarRubrosCertificados');
    } else {
      this.rubroReadOnly = false;
    }
  },
  methods: {
    getDatosAdicionales() {
      this.inicializandoRubros = true;
      this.$store.dispatch('ordentrabajo/getRubrosTrabajos')
        .then(() => this.inicializandoRubros = false)
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de rubros de trabajo.'));

      this.inicializandoCategorias = true;
      this.$store.dispatch('categoriasServicios/getList')
        .then(() => {
          this.categoriasServicios = this.$store.getters['categoriasServicios/list'];
          this.categoriasServiciosList = this.$store.getters['categoriasServicios/selectList'];
          this.inicializandoCategorias = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de categorías.'));

      this.inicializandoMonedas = true;
      this.$store.dispatch('monedas/getList')
        .then(() => {
          this.monedas = this.$store.getters['monedas/list'];
          this.monedasList = this.$store.getters['monedas/selectList'];
          this.inicializandoMonedas = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de monedas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titulo' || validarTodos) {
        if (this.$v.titulo.$error) {
          this.tituloValido = false;
          if (!this.$v.titulo.required) {
            this.tituloInvalidoMsj= 'Debe ingresar el título de la orden.';
          } else if (!this.$v.titulo.maxLength) {
            this.tituloInvalidoMsj = 'El título sólo puede contener hasta 30 caracteres';
          }
        } else {
          this.tituloValido = null;
          this.tituloInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

      if (campo == 'cantidad' || validarTodos) {
        if (this.$v.cantidad.$error) {
          this.cantidadValida = false;
          if (!this.$v.cantidad.numeric) {
            this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
          } else {
            if (!this.$v.cantidad.minValue) {
              this.cantidadInvalidaMsj = 'La cantidad ingresada no es válida';
            }      
          }
        } else {
          this.cantidadValida = null;
          this.cantidadInvalidaMsj = '';
        }
      }

      if (this.costoUnitario) {
        if (campo == 'costoEstimado' || validarTodos) {
          if (this.$v.costoEstimado.$error) {
            this.costoEstimadoValido = false;
            if (!this.$v.costoEstimado.decimal || !this.$v.costoEstimado.minValue) {
              this.costoEstimadoInvalidoMsj = 'El costo ingresado no es válido';
            }
          } else {
            this.costoEstimadoValido = null;
            this.costoEstimadoInvalidoMsj = '';
          }
        }
      } else {
        if (campo == 'costoEstimadoTotal' || validarTodos) {
          if (this.$v.costoEstimadoTotal.$error) {
            this.costoEstimadoTotalValido = false;
            if (!this.$v.costoEstimadoTotal.decimal || !this.$v.costoEstimadoTotal.minValue) {
              this.costoEstimadoTotalInvalidoMsj = 'El costo total ingresado no es válido';
            }
          } else {
            this.costoEstimadoTotalValido = null;
            this.costoEstimadoTotalInvalidoMsj = '';
          }
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let rubroTrabajoError = true;
      if (this.rubroTrabajo) {
        if (this.rubroTrabajo.id) {
          if (this.rubroTrabajo.id != 0) {
              rubroTrabajoError = false;
          }
        }
      }
      if (rubroTrabajoError) {
        this.rubroTrabajoValido = false;
        this.rubroTrabajoInvalidoMsj = 'Debe seleccionar el rubro correspondiente';
        save = false;
      }

      let errorMoneda = true;
      if (this.moneda) {
        if (this.moneda.id) {
          if (this.moneda.id != 0) {
            errorMoneda = false;
          }
        }
      }
      if (errorMoneda) {
        this.monedaValida = false;
        this.monedaInvalidaMsj = 'Debe seleccionar la moneda correspondiente.';
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          if (this.ordenId != 0) {
            this.$store.dispatch('ordentrabajo/saveOrden')
              .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
              .catch(error => this.showErrorMsj(error));
          } else {
            this.$store.dispatch('ordentrabajo/save')
              .then(() => {
                if (this.altaOrden) {
                  if (!this.vistaProduccion) {
                    this.$store.dispatch('presupuestointerno/addOrden', this.ordenTrabajo)
                      .then(() => this.$emit('updateOrdenes'))
                      .catch(error => this.showErrorMsj(error));
                  } else {
                    /* Pasamos como parámetro la orden generada */
                    this.$emit('updateOrdenes', this.ordenTrabajo);
                  }
                } else {
                  this.$store.dispatch('presupuestointerno/updateOrden', this.ordenTrabajo)
                    .then(() => this.$emit('updateOrdenes'))
                    .catch(error => this.showErrorMsj(error));
                }
              })
              .catch(error => this.showErrorMsj(error));
          }
        }
      }
    },
    goList() {
      this.$router.push({ name: 'OrdenesTrabajo' });
    },
    goBack() {
      if (this.ordenId != 0) {
        this.$router.push({ name: 'OrdenesTrabajo' });
      } else {
        this.$emit('closeOrden');
      }
    },
    rubroTrabajoActualizado(rubro) {
      if (!this.inicializandoRubros) {
        if (this.rubros) {
          if (this.rubros.length != 0) {
            let rubroTrabajo;
            this.rubroTrabajoNombre = rubro;
            if (this.rubroTrabajoNombre) {
              rubroTrabajo = this.getSelected(this.rubros, this.rubroTrabajoNombre);
              this.rubroTrabajoValido = null;
              this.rubroTrabajoInvalidoMsj = '';
            }
            this.$store.dispatch('ordentrabajo/setRubroTrabajo', rubroTrabajo);
          }
        }
      }
    },
    categoriaServicioActualizada(categoriaServicioNombre) {
      if (!this.inicializandoCategorias) {
        let categoriaServicio;
        if (categoriaServicioNombre) {
          categoriaServicio = this.getSelected(this.categoriasServicios, categoriaServicioNombre);
        }
        this.$store.dispatch('ordentrabajo/setCategoriaServicio', categoriaServicio);

        this.categoriaServicioValida = null;
        this.categoriaServicioInvalidaMsj = '';
      }
    },
    monedaActualizada(monedaNombre) {
      if (!this.inicializandoMonedas) {
        this.monedaNombre = monedaNombre;

        if (this.monedaNombre) {
          let moneda = this.getSelected(this.monedas, this.monedaNombre);
          this.$store.dispatch('ordentrabajo/setMoneda', moneda)
            .catch(error => this.showErrorMsj(error))

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    calcularCostos() {
      if ((/true/i).test(this.costoUnitario)) {
        this.$store.dispatch('ordentrabajo/calcularCostoTotal');  
      } else {
        this.$store.dispatch('ordentrabajo/calcularCostoUnitario');
      }     
    },
    // calcularCostoUnitario() {
    //   this.$store.dispatch('ordentrabajo/calcularCostoUnitario');
    // },
    // calcularCostoTotal() {
    //   this.$store.dispatch('ordentrabajo/calcularCostoTotal');
    // },
    actualizarCostoUnitario(params) {
      this.costoEstimado = params.importe;
      
      this.$store.dispatch('ordentrabajo/calcularCostoTotal')
        .catch(error => this.showErrorMsj(error));
    },
    actualizarCostoTotal(params) {
      this.costoEstimadoTotal = params.importe;
      
      this.$store.dispatch('ordentrabajo/calcularCostoUnitario')
        .catch(error => this.showErrorMsj(error));
    },
    askGpt() {
      this.$refs.gptModal.show();
    },
    closeGpt(params) {
      this.$refs.gptModal.hide();
      if (params) {
        if (params.updated) {
          this.descripcion = params.descripcion.trim();
        }
      }
    },
    askTranscriptionGpt() {
      this.$refs.gptTranscriptionModal.show();
    },
    closeTranscriptionGpt(params) {
      this.$refs.gptTranscriptionModal.hide();
      if (params) {
        if (params.updated) {
          this.descripcion = params.descripcion.trim();
        }
      }
    },
  },
  watch: {
  },    
  validations: {
    titulo: {
      required,
      maxLength: maxLength(30)
    },
    descripcion: {
      maxLength: maxLength(5000)
    },
    cantidad: {
      numeric,
      minValue: minValue(0),
    },
    costoEstimado: {
      decimal,
      minValue: minValue(0)
    },
    costoEstimadoTotal: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
  .custom-radio input[type='text'] {
    margin-left: 50%;
  }
  .text-costos {
    margin-top: 10px;
    margin-left: 120px !important;
  } 

  .icon-action {
    position: absolute;
    bottom: 0;
    right: 20px;  
    margin-left: 10px;
    color: #20a8d8;
    cursor: pointer;
  }
  .icon-action:hover {
    color: #1b8eb7;
  }
</style>
